module.exports = __webpack_public_path__ + "img/logo.de3e7ed1.png";